module.exports = __webpack_public_path__ + "img/base-hover.39fe12c4.png";